import { render } from "./MenuButton.vue?vue&type=template&id=6c387654&scoped=true&ts=true"
import script from "./MenuButton.vue?vue&type=script&lang=ts"
export * from "./MenuButton.vue?vue&type=script&lang=ts"

import "./MenuButton.vue?vue&type=style&index=0&id=6c387654&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c387654"]])

export default __exports__